import React from 'react'
import { Notification } from './notification.d'
import { Comment } from 'semantic-ui-react'
import { formatDistanceToNow } from 'date-fns'

interface Props {
    userName: string | null
    imageUrl: string | null
    notification: Notification
}

const NotificationItem: React.FC<Props> = (props: Props) => {
    const imageUrl = props.imageUrl || `${process.env.PUBLIC_URL}/avatar_placeholder.png`
    return (
        <Comment className="NotificationItem Comment">
            <Comment.Avatar src={imageUrl} />
            <Comment.Content>
                {props.userName && (
                    <Comment.Author as="a">{props.userName}</Comment.Author>
                )}
                {!props.userName && <Comment.Author as="a">Unknown User</Comment.Author>}
                <Comment.Metadata>
                    <div>
                        {formatDistanceToNow(props.notification.DateAdded)} ago
                        {props.notification.EndDate ? 
                        ' to ' + new Date(props.notification.EndDate).toLocaleString('en-US'
                        , {day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit'})
                        :
                        ''
                    }
                    </div>
                </Comment.Metadata>
                <Comment.Text>{props.notification.Subject && props.notification.Subject + ' - ' }{props.notification.Message}</Comment.Text>
                <Comment.Metadata>
                    {props.notification.RoomNames && props.notification.RoomNames.map((name)=>`${name} `)}
                </Comment.Metadata>
            </Comment.Content>
        </Comment>
    )
}

export default NotificationItem
